import { useRef, useState, useEffect, useCallback } from 'react'

import * as Styled from './styled'
import { TabbarItem } from './TabbarItem'
import { IProps } from './types'

export const Tabbar: React.FC<IProps> = ({
  data,
  activeTabName,
  setActiveTabName,
  className
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [tabWrapperRect, setTabWrapperRect] = useState({ width: 0, left: 0 })
  const [containerWidth, setContainerWidth] = useState(0)
  const tabsCount = data.length

  const handleTabClick = useCallback(
    (payload: string) => {
      setActiveTabName(payload)
    },
    [setActiveTabName]
  )

  const updateTabWrapperRect = useCallback(
    (width: number, left: number) => {
      setTabWrapperRect({ width, left })
    },
    [setTabWrapperRect]
  )

  const rightPosition =
    containerWidth - tabWrapperRect.left - tabWrapperRect.width

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [containerRef])

  return (
    <Styled.TabbarWrapper className={className}>
      <Styled.Tabbar $tabsCount={tabsCount} ref={containerRef}>
        {data.map(tab => {
          return (
            <TabbarItem
              {...tab}
              key={tab.id}
              isActive={activeTabName === tab.name}
              onClick={handleTabClick}
              updateTabWrapperRect={updateTabWrapperRect}
            />
          )
        })}

        {!!tabWrapperRect.width && (
          <Styled.ActiveTabLineWrapper
            $tabWrapperWidth={tabWrapperRect.width}
            $leftPosition={tabWrapperRect.left}
            $rightPosition={rightPosition}
          >
            <Styled.ActiveTabLine />
          </Styled.ActiveTabLineWrapper>
        )}
      </Styled.Tabbar>
    </Styled.TabbarWrapper>
  )
}

export default Tabbar
